export const USER_SET_DATA = 'USER_SET_DATA';
export const USER_LOGOUT = 'USER_LOGOUT';
